// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__YwKoc","createdSearch":"index_createdSearch__2VCaA","custom_table":"index_custom_table__yV3fi"};